const parseJson = (value: any, t: any = 'string') => {
  const returnJson = typeof value === t ? JSON.parse(value) : value
  return returnJson
}

export default parseJson